// ─── Navigation Config ────────────────────────────────────────────────────────
const NAV_CONFIG = [
  {
    section: 'Overview',
    items: [
      {
        id: 'dashboard',
        label: 'Dashboard',
         icon: '📊',
        role: ['owner'],   // ✅ only owner
      },
      {
        id: 'organiserDashboard',
        label: 'Organiser Dashboard',
        icon: '📊',
        role: ['organiser'], // ✅ only organiser
      },
    ],
  },
  {
    section: 'Masters',
    items: [
      { id: 'seasons', label: 'Seasons', icon: '🌾', badge: null, role: ['owner'] },
      { id: 'users', label: 'Users', icon: '👥', badge: null, role: ['owner'] },
      { id: 'organisers', label: 'Organisers', icon: '🏢', badge: null, role: ['organiser'] },
      { id: 'villages', label: 'Villages', icon: '🏘', badge: null },
      { id: 'farmers', label: 'Farmers', icon: '👨‍🌾', badge: null },
      { id: 'materials', label: 'Material Types', icon: '🌾', badge: null },
      { id: 'companies', label: 'Company', icon: '🏢', badge: null },
      { id: 'ledger', label: 'Ledger', icon: '📒', badge: null },
    ],
  },
  {
    section: 'Operations',
    items: [
      { id: 'accounts', label: 'Accounts', icon: '💰', badge: null },
      { id: 'distribution', label: 'Distribution', icon: '🚚', badge: '3' },
      { id: 'collection', label: 'Collection', icon: '📦', badge: null },
      { id: 'sales', label: 'Sales', icon: '🛒', badge: null },
      { id: 'production', label: 'Production', icon: '🏭', badge: null },
    ],
  },
  {
    section: 'Analytics',
    items: [
      { id: 'inventory', label: 'Inventory', icon: '📊', badge: null },
      { id: 'reports', label: 'Reports', icon: '📈', badge: null },
    ],
  },
];

export default NAV_CONFIG;
